if (!customElements.get('quick-add-button')) {
  class QuickAddButton extends HTMLElement {
    #clickHandler = this.handleClick.bind(this)

    constructor() {
      super()
    }

    connectedCallback() {
      this.addEventListener('click', this.#clickHandler)
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.#clickHandler)
    }

    handleClick(event) {
      const productUrl = this.dataset.productHref
      const quickModal = document.querySelector('quick-modal')
      const isLiveStreamingCard = this.classList.contains('live-streaming-card__quick-add')
      if (isLiveStreamingCard) {
        console.log('[Live streaming quick add] Click received', {
          eventType: event.type,
          target: event.target,
          productId: this.dataset.productId,
          productTitle: this.dataset.productTitle,
          productUrl,
          modalFound: Boolean(quickModal),
          modalActive: quickModal?.classList.contains('active'),
          modalLoading: quickModal?.classList.contains('loading'),
        })
      }
      if (!productUrl) {
        if (isLiveStreamingCard) console.warn('[Live streaming quick add] Missing product URL', this)
        return
      }
      if (!quickModal) {
        if (isLiveStreamingCard) console.error('[Live streaming quick add] Quick modal not found')
        return
      }

      quickModal.dataset.productHref = productUrl
      quickModal.dataset.pageType = this.dataset.pageType
      if (this.dataset.liveStream) {
        quickModal.dataset.liveStream = this.dataset.liveStream
      } else {
        delete quickModal.dataset.liveStream
      }
      delete quickModal.dataset.customPackOnly
      // The modal is shared by every opener, so regular products must clear the
      // clearance-only state left by a previous clearance card.
      if (this.dataset.showOnlyClearance) {
        quickModal.dataset.showOnlyClearance = this.dataset.showOnlyClearance
      } else {
        delete quickModal.dataset.showOnlyClearance
      }
      // The modal is a singleton, so this flag has to be cleared for openers that
      // do want the quantity control.
      if (this.dataset.hideQuantitySelector) {
        quickModal.dataset.hideQuantitySelector = this.dataset.hideQuantitySelector
      } else {
        delete quickModal.dataset.hideQuantitySelector
      }
      const isRebuyRecommendation = this.isRebuyRecommendation()
      if (isRebuyRecommendation) {
        quickModal.dataset.ruleId = this.closest('rebuy-recommendations').dataset.ruleId
      }
      const openPromise = quickModal.open(isRebuyRecommendation)
      if (isLiveStreamingCard) {
        console.log('[Live streaming quick add] Modal open started', {
          productId: this.dataset.productId,
          modalActive: quickModal.classList.contains('active'),
          modalLoading: quickModal.classList.contains('loading'),
          modalProductUrl: quickModal.dataset.productHref,
        })
        openPromise.then(
          () => {
            console.log('[Live streaming quick add] Modal open completed', {
              productId: this.dataset.productId,
              modalActive: quickModal.classList.contains('active'),
              modalLoading: quickModal.classList.contains('loading'),
              modalProductUrl: quickModal.dataset.productHref,
            })
          },
          (error) => {
            console.error('[Live streaming quick add] Modal open failed', {
              productId: this.dataset.productId,
              modalProductUrl: quickModal.dataset.productHref,
              error,
            })
          },
        )
      }
      this.sendDataLayer()
    }

    // Check if quick add button is inside a rebuy recommendation to send the correct flag
    isRebuyRecommendation() {
      return this.closest('rebuy-recommendations') ? true : false
    }

    sendDataLayer() {
      const productFormattedPrice = this.dataset.productFormattedPrice
      const currency = this.dataset.currency
      const title = this.dataset.productTitle
      const productId = Number(this.dataset.productId)
      const productVendor = this.dataset.productVendor
      const productType = this.dataset.productType

      dataLayer.push({ ecommerce: null })
      dataLayer.push({
        event: 'quick_add_to_cart_open',
        ecommerce: {
          value: productFormattedPrice,
          currency: currency,
          items: [
            {
              item_id: productId,
              item_name: title,
              item_brand: productVendor,
              item_category: productType,
              currency: currency,
              price: productFormattedPrice,
            },
          ],
        },
      })
    }
  }
  customElements.define('quick-add-button', QuickAddButton)
}
